
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RuleWrapper from "./components/rule-wrapper.vue";
import CustomRuleWrapper from "./components/custom-rule-wrapper.vue";
import { ExamComponent } from "@/lib/model/exambuilder/exam-component/exam";
import RuleForm from "./components/rule-form.vue";
import CustomRuleForm from "./components/custom-rule-form.vue";
import {
  Attr,
  AutoAudit,
  CustomRule
} from "@/lib/model/exambuilder/exam-component/application-rule";
import { cloneDeep } from "lodash-es";
import { DimensionObject } from "@/lib/model/exambuilder/dimension-v2";
import RuleFormItem from "./components/rule-form-item.vue";
import { ruleStore } from "@/store/rules";
import { CascadeOption } from "@/lib/model/exambuilder/exam-component/rule";
import { EnumQuestionType } from "@/lib/model/exambuilder/question-v2";

interface RuleItem {
  key: number;
  text: string;
  textColor: string;
  title: string;
  bgColor: string;
  icon: string;
  bdColor: string;
}

@Component({
  components: {
    RuleWrapper,
    RuleForm,
    CustomRuleForm,
    CustomRuleWrapper,
    RuleFormItem
  }
})
export default class SetAutoRule extends Vue {
  @Prop({ type: ExamComponent, default: null }) exam!: ExamComponent;
  @Prop({ type: Boolean }) isEdit!: boolean;

  private ruleList: RuleItem[] = [
    {
      key: 1,
      text: "通过",
      textColor: "#1DB26F",
      bgColor: "#DDF3E9",
      title: "通过条件",
      bdColor: "#85D4B0",
      icon: require("@/views/ai-builder-component/assets/rule/pass.svg")
    },
    {
      key: 2,
      text: "待定",
      textColor: "#FF9900",
      bgColor: "#FFEED5",
      bdColor: "#FFD18D",
      title: "待定条件",
      icon: require("@/views/ai-builder-component/assets/rule/pending.svg")
    },
    {
      key: 3,
      text: "拒绝",
      textColor: "#EB462D",
      bgColor: "#FCE3E0",
      bdColor: "#FFB9B1",
      title: "拒绝条件",
      icon: require("@/views/ai-builder-component/assets/rule/reject.svg")
    },
    {
      key: 4,
      text: "待评估",
      textColor: "#25B0FF",
      bgColor: "rgba(37,176,255,0.14)",
      bdColor: "rgba(37,176,255,0.28)",
      title: "待评估条件",
      icon: require("@/views/ai-builder-component/assets/rule/waiting.svg")
    }
  ];
  private solutionTypeList = [
    {
      title: "淘汰制",
      sort: [3, 2, 1],
      desc: "【拒绝】 → 【待定】 → 【通过】"
    },
    {
      title: "择优制",
      sort: [1, 2, 3],
      desc: "【通过】 → 【待定】 → 【拒绝】"
    },
    {
      title: "挑选制",
      sort: [3, 1, 2],
      desc: "【拒绝】 → 【通过】 → 【待定】"
    }
  ];
  private currentTypeIdx = 0;
  private auditList: any[] = [];
  private hasSeed = localStorage.getItem("ruleSeeked");

  async mounted() {
    localStorage.setItem("ruleSeeked", "1");
    const autoAuditList = this.exam.examVersionInfo.applicationRule
      .autoAuditList;
    if (!autoAuditList.length) {
      this.auditList.push(
        new AutoAudit(1).assign({ matchRuleList: [] }),
        new AutoAudit(2).assign({ matchRuleList: [] }),
        new AutoAudit(3).assign({ matchRuleList: [] })
      );
    } else {
      this.auditList = cloneDeep(autoAuditList);
    }
    if (!autoAuditList.length) {
      this.currentTypeIdx = 2;
    } else {
      const startStr = autoAuditList.map(item => item.auditStatus).join("");
      this.currentTypeIdx = this.solutionTypeList.findIndex(
        item => item.sort.join("") === startStr
      );
    }
    const { list } = await DimensionObject.get({
      dimensionKeyList: this.exam.examVersionInfo.dimensions.dimensionConfigList.map(
        item => item.dimensionKey
      ),
      isExamEnv: 1,
      withExamId: this.exam.metaInfo.examId
    });

    const dimensionBaseList = list.map(item => {
      const list = this.exam.examVersionInfo.dimensions.dimensionGroupList;
      const group = list.find(group =>
        group.dimensionKeyList.includes(item.dimensionKey)
      );
      return {
        label: item.dimensionName,
        value: item.dimensionKey,
        children: null,
        list: group.levelDesc
      };
    });
    const dimesionGroupList = this.exam.examVersionInfo.dimensions.dimensionGroupList.map(
      item => {
        return {
          label: item.groupName,
          value: item.groupName,
          list: item.levelDesc,
          children: null
        };
      }
    );
    const question = this.exam.examVersionInfo.questionSelectedList;
    const questionList = question
      .filter(
        item =>
          item.questionType === EnumQuestionType.EnumQuestionTypeNewSingleChoice
      )
      .map(item => ({
        label: item.descTextOnly,
        value: `${item.questionId}`,
        children: null,
        list: item.optionList.map(child => child.optionKey)
      }));
    const choiceList: CascadeOption[] = [];
    const multiChoiceList: CascadeOption[] = [];
    const paramsIdList: CascadeOption[] = [];
    for (const item of this.exam.examVersionInfo.paramList) {
      if (item.isShow !== 1) continue;
      if (item.inputType === "choice") {
        choiceList.push({
          label: item.name,
          value: item.name,
          children: null,
          list: item.singleChoiceOptions
        });
      }
      if (item.inputType === "multiChoice") {
        multiChoiceList.push({
          label: item.name,
          value: item.name,
          children: null,
          list: item.mutiChoiceOptions.map(child => child.key)
        });
      }
      if (item.inputType === "idcard") {
        paramsIdList.push({
          label: item.name,
          value: item.name,
          children: null
        });
      }
    }
    await ruleStore.getAllAttrs({
      dimensionBaseList: dimensionBaseList,
      dimensionGroupList: dimesionGroupList,
      paramsChoiceList: choiceList,
      paramsMultiChoiceList: multiChoiceList,
      questionList: questionList,
      paramsIdList: paramsIdList
    });
  }

  get currentSolution() {
    return this.solutionTypeList[this.currentTypeIdx];
  }
  get ruleInfo() {
    const info: any = {};
    this.auditList.forEach(item => {
      info[item.auditStatus] = item.matchRuleList.map((item: any) => {
        this.$set(item, "expanded", false);
        return item;
      });
    });
    return info;
  }

  get ruleSortList() {
    const sort = this.solutionTypeList[this.currentTypeIdx].sort;
    return sort.map(item => {
      const params = this.ruleList.find(child => child.key === item)!;
      return {
        ...params,
        rules: this.ruleInfo[item]
      };
    });
  }

  get otherRuleList() {
    return this.exam.examVersionInfo.applicationRule.customList;
  }

  get lastSort(): RuleItem {
    const sorts = this.solutionTypeList[this.currentTypeIdx].sort;
    return this.ruleList.find(item => item.key === sorts[sorts.length - 1])!;
  }

  handleChangeTab(i: number) {
    const needTip = this.auditList.find(item => item.matchRuleList.length);
    if (needTip) {
      this.$confirm("切换评估模式会清空现有配置，请谨慎操作", "提示", {
        confirmButtonText: "清空",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        for (const item of this.auditList) {
          this.$set(item, "matchRuleList", []);
        }
        this.currentTypeIdx = i;
      });
      return;
    }
    this.currentTypeIdx = i;
  }

  handleAdd(status: number, element?: any) {
    (this.$refs.ruleForm as any).add(+status, element);
  }

  handleEdit(element: any, status: number, idx: number) {
    (this.$refs.ruleForm as any).edit(element, +status, idx);
  }

  handleCopy(element: any, status: number) {
    const ruleList = this.auditList.find(item => item.auditStatus === status)
      ?.matchRuleList;
    if (!ruleList) return;
    const copy = cloneDeep(element);
    copy.name = "";
    copy.remark = "";
    this.handleAdd(status, copy);
  }

  handleDelete(status: number, idx: number) {
    this.$confirm("确定删除该条件组合？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      const ruleList = this.auditList.find(item => item.auditStatus === status)
        ?.matchRuleList;
      if (!ruleList) return;
      ruleList.splice(idx, 1);
    });
  }

  handleCommand(command: string, element: any, status: number, idx: number) {
    switch (command) {
      case "edit":
        this.handleEdit(element, status, idx);
        break;
      case "copy":
        this.handleCopy(element, status);
        break;
      case "delete":
        this.handleDelete(status, idx);
        break;
    }
  }

  handleCustomAdd(element?: any) {
    (this.$refs.customRuleForm as any).add(element);
  }

  handleCustomEdit(element: any, idx: number) {
    (this.$refs.customRuleForm as any).edit(element, idx);
  }

  handleCustomCopy(element: any) {
    const copy = cloneDeep(element);
    copy.matchRule.name = "";
    copy.matchRule.remark = "";
    this.handleCustomAdd(copy);
  }

  handleCustomDelete(idx: number) {
    this.$confirm("确定删除该条件组合？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      const ruleList = this.exam.examVersionInfo.applicationRule.customList;
      if (!ruleList) return;
      ruleList.splice(idx, 1);
    });
  }

  handleCustomCommand(command: string, element: any, idx: number) {
    switch (command) {
      case "edit":
        this.handleCustomEdit(element, idx);
        break;
      case "copy":
        this.handleCustomCopy(element);
        break;
      case "delete":
        this.handleCustomDelete(idx);
        break;
    }
  }

  handleAddRule(result: Attr, status: number, idx: number | undefined) {
    const ruleList = this.auditList.find(item => item.auditStatus === status)
      ?.matchRuleList;
    if (!ruleList) return;
    if (idx === undefined) {
      ruleList.push(result);
    } else {
      ruleList.splice(idx, 1, result);
    }
  }

  handleAddCustomRule(result: CustomRule, idx: number | undefined) {
    const ruleList = this.exam.examVersionInfo.applicationRule.customList;
    if (idx === undefined) {
      ruleList.push(result);
    } else {
      ruleList.splice(idx, 1, result);
    }
  }

  changeRule(status: number, ruleList: any) {
    const rules = this.auditList;
    const item = rules.find(item => item.auditStatus === status);
    if (!item) return;
    item.matchRuleList = ruleList;
  }

  changeCustomRule(ruleList: any) {
    this.exam.examVersionInfo.applicationRule.customList = ruleList;
  }

  checkData() {
    if (this.currentTypeIdx !== 3) {
      this.exam.examVersionInfo.applicationRule.autoAuditList = this.auditList;
    } else {
      this.exam.examVersionInfo.applicationRule.autoAuditList = [];
    }
    return true;
  }

  @Watch("currentTypeIdx", { immediate: true })
  changeCurrentTypeIdx(val: number) {
    if (val === 3) return;
    this.$nextTick(() => {
      const sorts = this.solutionTypeList[val].sort;
      const newAuditList = sorts.map(item => {
        return this.auditList.find(child => child.auditStatus === item)!;
      });
      this.auditList = newAuditList;
    });
    const sorts = this.solutionTypeList[val].sort;
    const clearIdx = sorts[sorts.length - 1];
    const item = this.auditList.find(child => child.auditStatus === clearIdx);
    if (!item) return;
    item.matchRuleList = [];
  }

  beforeDestroy() {
    this.exam.examVersionInfo.applicationRule.autoAuditList = this.auditList;
  }
}
